import React, { useMemo, useState } from 'react';
import ItemCategoryFilter from '@/components/filters/ItemCategoryFilter';
import TreeFilter from '@/components/filters/TreeFilter';
import { CatalogFilterData } from '@/types';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { FilterButtons, FilterPopOut, useIsFilterModified } from '@ygtechnologies/bygr-frontend-component-library';

interface CatalogGroupFilterProps {
    filter: CatalogFilterValue;
    onChange: (newValue: CatalogFilterValue) => void;
    isLoading: boolean;
    data: CatalogFilterData;
}

export interface CatalogFilterValue {
    searchText: string;
    itemCategoryIds: number[];
    suppliers: string[];
}
export class CatalogFilterValue {
    static empty(): CatalogFilterValue {
        return {
            searchText: '',
            itemCategoryIds: [],
            suppliers: [],
        };
    }
}

export const CatalogFilter: React.FC<CatalogGroupFilterProps> = ({ data, filter, onChange, isLoading }) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const suppliers = useMemo(() => {
        const result = data.suppliers.map((x) => ({ id: x, name: x }));
        result.push({ id: '', name: t`Show products without supplier` });
        return result;
    }, [data]);
    const filterModified = useIsFilterModified(filter, CatalogFilterValue.empty);

    return (
        <>
            <FilterButtons
                isLoading={isLoading}
                searchText={filter.searchText}
                onSearchTextChange={(v) => onChange({ ...filter, searchText: v })}
                onButtonClick={() => setIsFilterOpen((v) => !v)}
                isActive={filterModified}
            />

            <FilterPopOut
                onClear={() => onChange(CatalogFilterValue.empty())}
                onClose={() => setIsFilterOpen(false)}
                isVisible={isFilterOpen}>
                <label className="filter-label">
                    <Trans>Category</Trans>
                </label>
                <ItemCategoryFilter
                    value={filter.itemCategoryIds}
                    onChange={(v) => onChange({ ...filter, itemCategoryIds: v })}
                />

                <label className="filter-label">
                    <Trans>Supplier</Trans>
                </label>
                <TreeFilter
                    data={suppliers}
                    value={filter.suppliers}
                    idField="id"
                    nameField="name"
                    onChange={(v) => onChange({ ...filter, suppliers: v })}
                />
            </FilterPopOut>
        </>
    );
};
